function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleSearchConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "38px",
    height: "34px",
    viewBox: "0 0 38 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(48.235294%,48.235294%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 10.65625 2.835938 L 13.480469 0.00390625 L 13.480469 5.410156 L 10.65625 5.410156 Z M 27.34375 2.835938 L 24.519531 0.00390625 L 24.519531 5.410156 L 27.34375 5.410156 Z M 27.34375 2.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.294118%,35.294118%,35.294118%)",
      fillOpacity: 1
    },
    d: "M 13.480469 0.00390625 L 24.519531 0.00390625 L 24.519531 2.707031 L 13.480469 2.707031 Z M 13.480469 0.00390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.196078%,90.588235%,90.980392%)",
      fillOpacity: 1
    },
    d: "M 34.917969 33.996094 L 3.082031 33.996094 C 1.378906 33.996094 0 32.613281 0 30.90625 L 0 10.722656 L 5.292969 5.410156 L 32.707031 5.410156 L 38 10.722656 L 38 30.90625 C 38 32.613281 36.621094 33.996094 34.917969 33.996094 Z M 34.917969 33.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.568627%,81.960784%,82.352941%)",
      fillOpacity: 1
    },
    d: "M 0 16.355469 L 0 10.722656 L 5.292969 5.410156 L 32.707031 5.410156 L 38 10.722656 L 38 16.355469 Z M 0 16.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(27.058824%,54.901961%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 4.363281 33.996094 L 4.363281 12.105469 C 4.363281 11.394531 4.941406 10.820312 5.648438 10.820312 L 32.351562 10.820312 C 33.058594 10.820312 33.636719 11.394531 33.636719 12.105469 L 33.636719 33.996094 Z M 4.363281 33.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.363281 16.355469 L 33.636719 16.355469 L 33.636719 33.996094 L 4.363281 33.996094 Z M 4.363281 16.355469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.352941%,82.745098%,83.137255%)",
      fillOpacity: 1
    },
    d: "M 24.90625 33.996094 L 24.90625 28.71875 L 22.335938 26.144531 L 20.667969 21.507812 L 21.824219 18.546875 L 28.371094 25.113281 L 29.527344 20.21875 L 33.636719 24.339844 L 33.636719 33.996094 Z M 24.90625 33.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(82.352941%,82.745098%,83.137255%)",
      fillOpacity: 1
    },
    d: "M 6.289062 18.417969 L 16.046875 18.417969 L 16.046875 29.363281 L 6.289062 29.363281 Z M 6.289062 31.808594 L 18.871094 31.808594 L 18.871094 33.996094 L 6.289062 33.996094 Z M 6.289062 31.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(31.372549%,31.372549%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 27.34375 29.890625 L 27.34375 33.996094 L 21.953125 33.996094 L 21.953125 29.949219 C 19.707031 28.925781 18.257812 26.691406 18.230469 24.21875 C 18.203125 21.742188 19.605469 19.476562 21.824219 18.402344 L 21.824219 24.46875 L 24.519531 26.144531 L 27.34375 24.46875 L 27.34375 18.402344 C 29.542969 19.46875 30.941406 21.699219 30.941406 24.148438 C 30.941406 26.59375 29.542969 28.828125 27.34375 29.890625 Z M 27.34375 29.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.196078%,90.588235%,90.980392%)",
      fillOpacity: 1
    },
    d: "M 7.382812 12.234375 C 7.984375 12.234375 8.472656 12.726562 8.472656 13.328125 C 8.472656 13.933594 7.984375 14.425781 7.382812 14.425781 C 6.777344 14.425781 6.289062 13.933594 6.289062 13.328125 C 6.289062 12.726562 6.777344 12.234375 7.382812 12.234375 Z M 10.589844 12.234375 C 11.195312 12.234375 11.683594 12.726562 11.683594 13.328125 C 11.683594 13.933594 11.195312 14.425781 10.589844 14.425781 C 9.988281 14.425781 9.5 13.933594 9.5 13.328125 C 9.5 12.726562 9.988281 12.234375 10.589844 12.234375 Z M 10.589844 12.234375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSearchConsole);
export default __webpack_public_path__ + "static/media/Google_Search_Console.8a109014862889879ebe28e49e5f623b.svg";
export { ForwardRef as ReactComponent };